export default "__VITE_ASSET__tS$1gwg1__"